import * as React from 'react';
import './TrialTreatmentPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { ITrialTreatmentReduxFormState, initialTrialTreatmentState } from "../../../reducers/reactReduxForms/trialTreatment";
import { IRegistrationElement, RegistrationFormComponent, IRegistrationGrid } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent, getFormProperty, getFormPropertyLabel } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveError, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, GenericFormGroup, RadioButtonSetFormInput, SelectFormInput, DatePickerFormInputFabric, DatePickerFormInput, DatePickerPartialFormInput, MaskedFormInput, NumberFormInput, CheckboxFormInput, StaticFormInput, GenericMultiFormGroup, ValidationMessage } from "../../../components/form/index";
import * as TrialTreatmentActions from '../../../actions/trialTreatment';
import * as TrialActions from '../../../actions/trial';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { Modal, NotificationAlert } from "../../../components/common/index";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { Form, actions, Control } from 'react-redux-form';
import { TrialLayout } from '../../index';
interface ITrialTreatmentPageParams {
  trialId: number;
  trialTreatmentId: number;
}
interface ITrialTreatmentPageProps {
  form: Dtos.TrialTreatment & IRegistrationFormState;
  formState: Dtos.FormState;
  formProperties: Dtos.FormProperty[];
  reduxFormState: ITrialTreatmentReduxFormState;
  location: Location;
  trialId: number;
  trialTreatmentId: number;
  match: match<ITrialTreatmentPageParams>;
  history: History;

  // From state
  trialTreatment: Dtos.TrialTreatment;
  trial: Dtos.Trial;
  lookups: Dtos.Lookup[];
  loadingTrial: boolean;
  loadingTrialTreatment: boolean;
  loadTrialTreatmentSuccess: boolean;
  loadTrialTreatmentFailure: boolean;
  savingTrialTreatment: boolean;
  saveTrialTreatmentSuccess: boolean;
  saveTrialTreatmentFailure: boolean;
  creatingTrialTreatment: boolean;
  createTrialTreatmentSuccess: boolean;
  createTrialTreatmentFailure: boolean;
  validationFailures: Dtos.ResponseError[];
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
}
interface ITrialTreatmentPageActions {
  clearTrialTreatment: TrialTreatmentActions.ITrialTreatmentClearActionCreator;
  loadTrialTreatment: TrialTreatmentActions.ITrialTreatmentLoadByIdActionCreator;
  saveTrialTreatment: TrialTreatmentActions.ITrialTreatmentSaveActionCreator;
  createTrialTreatment: TrialTreatmentActions.ITrialTreatmentCreateActionCreator;
  clearTrial: TrialActions.ITrialClearActionCreator;
  loadTrial: TrialActions.ITrialLoadByIdActionCreator;
  loadForm: typeof actions.load;
  changeForm: typeof actions.change;
  resetForm: typeof actions.reset;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
}
type TrialTreatmentPageProps = ITrialTreatmentPageProps & ITrialTreatmentPageActions;
const formName: string = "trialTreatment";
const reduxFormName: string = "reduxForms.trialTreatment";
const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex";
const tableStyleClass: React.CSSProperties = {
  textAlign: "left",
  fontWeight: "bold",
  color: "white",
  cursor: "pointer"
};
class TrialTreatmentPage extends React.PureComponent<TrialTreatmentPageProps, any> {
  constructor(props: TrialTreatmentPageProps) {
    super(props);
    this.clearTrialTreatment = this.clearTrialTreatment.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.loadForm = this.loadForm.bind(this);
  }
  componentDidMount() {
    const {
      loadTrialTreatment,
      navigate,
      navigateReplace,
      trialTreatmentId,
      trialId,
      loadTrial,
      createTrialTreatment
    } = this.props;
    if (trialTreatmentId) {
      loadTrialTreatment(trialTreatmentId);
    } else {
      // change to create
      createTrialTreatment(trialId);
    }
    loadTrial(trialId, false, false, false, false, false);
  }
  componentWillReceiveProps(nextProps: TrialTreatmentPageProps) {}
  componentDidUpdate(prevProps: TrialTreatmentPageProps, prevState) {
    const {
      form,
      trialId,
      trialTreatmentId,
      trialTreatment,
      navigateReplace,
      loadTrialTreatment,
      loadTrial,
      loadingTrialTreatment,
      loadTrialTreatmentSuccess,
      savingTrialTreatment,
      saveTrialTreatmentSuccess,
      saveTrialTreatmentFailure,
      validationFailures,
      navigate,
      createTrialTreatment,
      creatingTrialTreatment,
      createTrialTreatmentSuccess
    } = this.props;
    if (trialId && prevProps.trialId != trialId) {
      loadTrial(trialId, false, false, false, false, false);
    }
    if (trialTreatmentId && prevProps.trialTreatmentId != trialTreatmentId) {
      loadTrialTreatment(trialTreatmentId);
    } else if (!trialTreatmentId && prevProps.trialTreatmentId) {
      createTrialTreatment(trialId);
    }
    if (!loadingTrialTreatment && prevProps.loadingTrialTreatment) {
      if (loadTrialTreatmentSuccess) {
        this.loadForm();
      } else {}
    }
    if (!savingTrialTreatment && prevProps.savingTrialTreatment) {
      if (saveTrialTreatmentSuccess) {
        if (validationFailures && validationFailures.length > 0) {
          Alert.warning(<NotificationAlert alertContent={renderRegistrationFormSaveWarning(validationFailures)} icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE} />);

          // toggleMessageModal();
        } else {
          Alert.success(<NotificationAlert alertContent={renderRegistrationFormSaveSuccess()} icon={FontAwesomeIcons.Solid.CHECK} />);
        }
        if (form.saveAndReturn) {
          navigate("/trials/" + trialId + "/treatments");
        } else if (!form.saveAndReturn && trialTreatmentId && trialTreatmentId > 0) {
          this.loadForm();
        } else if (!form.saveAndReturn && !trialTreatmentId && trialTreatment && trialTreatment.id > 0) {
          navigate("/trials/" + trialId + "/treatments/" + trialTreatment.id);
        }
      } else {
        Alert.error(<NotificationAlert alertContent={this.renderErrorAlert()} icon={FontAwesomeIcons.Solid.TIMES_OCTAGON} />);
      }
    }
    if (!creatingTrialTreatment && prevProps.creatingTrialTreatment) {
      if (createTrialTreatmentSuccess) {
        this.loadForm();
      } else {}
    }
  }
  componentWillUpdate(nextProps: TrialTreatmentPageProps) {}
  componentWillUnmount() {
    const {
      resetForm,
      loadForm
    } = this.props;
    this.clearTrialTreatment();
    loadForm(reduxFormName, initialTrialTreatmentState);
    resetForm(reduxFormName);
  }
  clearTrialTreatment() {
    this.props.clearTrialTreatment();
    this.props.clearTrial();
  }
  showTrialTreatment(): boolean {
    const {
      loadingTrial,
      loadingTrialTreatment,
      loadTrialTreatmentSuccess
    } = this.props;
    if (!loadingTrial && !loadingTrialTreatment && loadTrialTreatmentSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingTrial,
      loadingTrialTreatment
    } = this.props;
    return <TrialLayout loading={loadingTrial || loadingTrialTreatment} permission={Dtos.Permission.TrialTreatmentsView} data-sentry-element="TrialLayout" data-sentry-component="TrialTreatmentPage" data-sentry-source-file="TrialTreatmentPage.tsx">{this.renderContent()}</TrialLayout>;
  }
  renderContent() {
    const {
      form,
      trialTreatment,
      trialTreatmentId,
      loadingTrialTreatment,
      loadTrialTreatmentSuccess,
      loadTrialTreatmentFailure,
      clearTrialTreatment,
      navigate,
      permissions,
      lookups,
      validationFailures,
      formProperties,
      formState,
      changeForm,
      savingTrialTreatment
    } = this.props;
    const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TrialTreatmentsUpdate, Dtos.Permission.TrialTreatmentsCreate);
    const formDisabled: boolean = !hasPermission || savingTrialTreatment || formState && formState.formStatus == Dtos.FormStatus.Disabled;
    let formComponents: {
      [index: string]: RegistrationFormComponent;
    } = {
      name: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled
      },
      shortName: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled
      },
      duration: {
        type: RegistrationComponent.RegistrationControl,
        inputType: NumberFormInput,
        inputDisabled: formDisabled
      },
      targetAccrual: {
        type: RegistrationComponent.RegistrationControl,
        inputType: NumberFormInput,
        inputDisabled: formDisabled
      },
      active: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "Active"
        },
        inputLabel: " "
      }
    };
    return <div>
            <h3>Treatment</h3>
            <Form model={reduxFormName} onSubmit={(val, event) => this.handleOnSubmit(val)} onSubmitFailed={val => this.handleOnSubmitFailed(val)}>

                {renderFormControls(form, "trialTreatment", formComponents, lookups, validationFailures, formProperties, changeForm)}

                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", false);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit
                    </button>

                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2"> Cancel </button>
                </div>
            </Form>
        </div>;
  }
  renderErrorAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was <strong> not </strong> saved.
            </div>;
  }
  renderWarningAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>;
  }
  renderSaveSuccessAlert(): any {
    return <div>The form has been saved successfully</div>;
  }
  handleOnSubmit(data: Dtos.TrialTreatment) {
    const {
      saveTrialTreatment
    } = this.props;
    if (data) {
      let changes: Dtos.TrialTreatment = ({} as Dtos.TrialTreatment);
      saveTrialTreatment(Object.assign({
        ...data
      }, changes));
    }
  }
  handleOnSubmitFailed(data: Dtos.TrialTreatment) {
    Alert.error(<NotificationAlert minWidth={500} alertContent={renderRegistrationFormSaveBlock()} icon={FontAwesomeIcons.Solid.BAN} />);
  }
  onCancel() {
    const {
      trialId,
      navigate
    } = this.props;
    navigate("/trials/" + trialId + "/treatments");
  }
  loadForm() {
    const {
      loadForm,
      trialTreatment
    } = this.props;
    let extraData: Dtos.TrialTreatment = ({} as Dtos.TrialTreatment);
    loadForm(reduxFormName, Object.assign({
      ...trialTreatment
    }, extraData));
  }
}
const mapStateToProps = (state: ITmdState, ownProps: TrialTreatmentPageProps): ITrialTreatmentPageProps => {
  let trialTreatment: Dtos.TrialTreatment | undefined = !(state.trialTreatment.formData instanceof Array) ? state.trialTreatment.formData : undefined;
  let trial: Dtos.Trial | undefined = !(state.trials.formData instanceof Array) ? state.trials.formData : undefined;
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    match: ownProps.match,
    trialId: ownProps.match ? ownProps.match.params.trialId : undefined!,
    trialTreatmentId: ownProps.match && ownProps.match.params.trialTreatmentId && ownProps.match.params.trialTreatmentId.toString() != "create" ? ownProps.match.params.trialTreatmentId : undefined!,
    history: ownProps.history,
    location: state.routing.location,
    trialTreatment: trialTreatment!,
    trial: trial!,
    loadingTrialTreatment: state.trialTreatment.loadState && state.trialTreatment.loadState.status == RequestState.Pending,
    loadTrialTreatmentSuccess: state.trialTreatment.loadState && state.trialTreatment.loadState.status == RequestState.Success,
    loadTrialTreatmentFailure: state.trialTreatment.loadState && state.trialTreatment.loadState.status == RequestState.Failure,
    loadingTrial: state.trials.loadState && state.trials.loadState.status == RequestState.Pending,
    savingTrialTreatment: state.trialTreatment.saveState && state.trialTreatment.saveState.status == RequestState.Pending,
    saveTrialTreatmentSuccess: state.trialTreatment.saveState && state.trialTreatment.saveState.status == RequestState.Success,
    saveTrialTreatmentFailure: state.trialTreatment.saveState && state.trialTreatment.saveState.status == RequestState.Failure,
    creatingTrialTreatment: state.trialTreatment.createState && state.trialTreatment.createState.status == RequestState.Pending,
    createTrialTreatmentSuccess: state.trialTreatment.createState && state.trialTreatment.createState.status == RequestState.Success,
    createTrialTreatmentFailure: state.trialTreatment.createState && state.trialTreatment.createState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    lookups: state.trialTreatment.lookups,
    form: state.reduxForms.trialTreatment,
    formState: state.trialTreatment.formState,
    formProperties: state.trialTreatment.formProperties,
    reduxFormState: state.reduxForms.formState.trialTreatment,
    validationFailures: trialTreatment ? state.trialTreatment.validationFailures : undefined
  };
};
const mapDispatchToProps = (dispatch): ITrialTreatmentPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadForm: bindActionCreators(actions.load, dispatch),
    changeForm: bindActionCreators(actions.change, dispatch),
    resetForm: bindActionCreators(actions.reset, dispatch),
    loadTrialTreatment: bindActionCreators(TrialTreatmentActions.LoadTrialTreatmentById, dispatch),
    clearTrialTreatment: bindActionCreators(TrialTreatmentActions.Clear, dispatch),
    saveTrialTreatment: bindActionCreators(TrialTreatmentActions.SaveTrialTreatment, dispatch),
    createTrialTreatment: bindActionCreators(TrialTreatmentActions.CreateTrialTreatment, dispatch),
    loadTrial: bindActionCreators(TrialActions.LoadTrialById, dispatch),
    clearTrial: bindActionCreators(TrialActions.Clear, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TrialTreatmentPage);